import { selectChangeMessageForGoalRelations } from '@UI/aside/asideGoalRelations/asideGoalRelationsSelectors';
import { selectChangeMessageForPreviousVersionItems } from '@UI/aside/asidePreviousVersionItems/AsidePreviousVersionItemsSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectGoalSubItem } from '@newStore/documentUI/transformContent/llinkidSelectors';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { llinkidDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';

const LLINID_INITIAL_SITUATION: BuildingBlockNodeConfig = {
  nodeSelector: selectGoalSubItem,
  information: {
    single: 'Beginsituatie',
    plural: 'Beginsituaties',
  },
  buildingBlocks: [],
  edit: [
    llinkidDescriptionComponent,
    {
      component: 'goalRelations',
      reactComponent: 'AsideGoalRelations',
      label: 'Beginsituatie',
      options: {
        relationTypes: ['REFERENCES'],
        modal: 'llinkidGoalRelationsModal',
        listColumn: 'description',
        modalTitle: 'Specifieke leerplandoelen beginsituatie',
        toType: ContentType.LLINKID_GOAL,
      },
      asideChangeMessageSelector: selectChangeMessageForGoalRelations,
    },
    {
      component: 'previousVersionItems',
      reactComponent: 'AsidePreviousVersionItems',
      label: 'Vervangt (uit vorige versie)',
      options: {
        relationTypes: ['REPLACES'],
        modal: 'llinkidPreviousVersionModal',
        modalTitle: 'Vervangt (uit vorige versie)',
        listColumn: 'description',
        placeholder: 'Kies een te vervangen beginsituatie',
        relation: 'Beginsituatie',
        errorMessage: 'Je moet een geldige beginsituatie selecteren',
        type: ContentType.LLINKID_INITIAL_SITUATION,
      },
      asideChangeMessageSelector: selectChangeMessageForPreviousVersionItems,
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    focusOnField: 'description',
  },
};

export default LLINID_INITIAL_SITUATION;
